import {Component, Input} from '@angular/core';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {TransactionListCta, TransactionType} from '@dcp/configurator';
import {LeadService} from '../../../services/lead.service';

@Component({
  selector: 'dcp-lead-form-login',
  templateUrl: './lead-form-login.component.html',
  styleUrls: ['./lead-form-login.component.scss']
})
export class LeadFormLoginComponent {

  @Input() transactionType: TransactionType;
  @Input() transactionListCta: TransactionListCta;

  constructor(public authService: DcpAuthService,
              public leadService: LeadService) {
  }

  /**
   * Makes sure that the lead form is opened again after login and redirects the user to IDS.
   */
  logUserIn() {
    this.leadService.leadFormLastOpened = {
      transactionType: this.transactionType,
      transactionListCta: this.transactionListCta
    };
    this.authService.login();
  }
}
